import { GetterTree } from 'vuex';
import { Auth } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<Auth, any> = {
  getIsAuth(state: Auth): boolean {
    return state.isAuth;
  },

  getEmail(state) {
    return state.user.email;
  },
};

export default getters;
